<template>
  <div>
    <b-card>
      <b-card-header>
        <h2>
          <feather-icon icon="LayersIcon" />
          {{ $t('Routes.addTypeEquipment') }}
        </h2>
      </b-card-header>
      <b-card-body>
        <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
          <b-form @submit.prevent="handleSubmit(onSubmit)" @reset.prevent="resetForm">
            <b-row>
              <b-col cols="12">
                <validation-provider #default="{errors}" :name="$t('AppTI.equipment.type')" rules="required">
                  <b-form-group :label="$t('AppTI.equipment.type')" label-for="type">
                    <b-form-input type="text" :placeholder="$t('AppTI.equipment.type')" v-model="typeEquipmentData.nombre" />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12">
                <validation-provider #default="{ errors }" :name="$t('AppTI.equipment.description')"
                rules="required|max:1025">
                <b-form-group :label="$t('AppTI.equipment.description')" label-for="description">
                  <b-form-textarea id="description" v-model="typeEquipmentData.descripcion" rows="3"
                    :placeholder="$t('AppTI.equipment.description')" />
                  <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
              </b-col>
            </b-row>
            <b-row class="float-right mt-2 mb-2">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-2" type="submit">
                <b-spinner v-if="addingType" small class="mr-1" />
                {{ $t('Lists.Add') }}
              </b-button>
            </b-row>
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BButton,
  BSpinner,
  BForm,
  BFormInput,
  BFormTextarea,
  BFormGroup,
  BFormInvalidFeedback,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {
  required,
} from '@validations'
import tiService from '@/services/informationTecnology.service'
import formValidation from '@core/comp-functions/forms/form-validation'
import { ref } from '@vue/composition-api'
import router from '@/router'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BButton,
    BSpinner,
    BForm,
    BFormInput,
    BFormTextarea,
    BFormGroup,
    BFormInvalidFeedback,

    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  setup() {
    const typeEquipmentData = ref({
      tipoEquipoId: 0,
      nombre: '',
      descripcion: '',
      archivado: false,
    })
    const typeEquipmentBlak = {
      tipoEquipoId: 0,
      nombre: '',
      descripcion: '',
      archivado: false,
    }

    const resetTypeData = () => {
      typeEquipmentData.value = JSON.parse(JSON.stringify(typeEquipmentBlak))
    }
    const addingType = ref(false)

    const { createTypeEquipment } = tiService()

    const {
      refFormObserver,
      resetForm,
      getValidationState,
    } = formValidation(resetTypeData)

    const onSubmit = () => {
      addingType.value = false
      createTypeEquipment(typeEquipmentData.value)
        .then(() => {
          addingType.value = false
          router.push({ name: 'apps-type-equipment-list' })
        })
    }
    return {
      refFormObserver,
      resetForm,
      getValidationState,
      typeEquipmentData,
      addingType,
      onSubmit,
    }
  },
}
</script>
